import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isValidContactPhone(phone: string) {
  const digits = phone.replace(/\D/g, '');
  return /^\+?[\d\s.()-]+$/.test(phone.trim()) && digits.length >= 9 && digits.length <= 15;
}
